import Absolute from "public/customerLogos/absolute.png";
import Airtel from "public/customerLogos/airtel.png";
import Amadeus from "public/customerLogos/amadeus.png";
import CoveredCalifornia from "public/customerLogos/covered_california.png";
import Helpage from "public/customerLogos/helpag.png";
import Hpe from "public/customerLogos/hpe.png";
import Italtel from "public/customerLogos/italtel.png";
import Mgic from "public/customerLogos/mgic.png";
import Nsc from "public/customerLogos/nsc.png";
import Ntt from "public/customerLogos/ntt.png";
import OnxCanada from "public/customerLogos/onxcanada.png";
import Opentext from "public/customerLogos/opentext.png";
import Sdaia from "public/customerLogos/sdaia.png";
import Shi from "public/customerLogos/shi.png";
import Shu from "public/customerLogos/shu.png";
import SoftwareOne from "public/customerLogos/softwareone.png";
import TeConnectivity from "public/customerLogos/te_connectivity.png";
import Toyota from "public/customerLogos/toyota.png";
import Uroclear from "public/customerLogos/uroclear.png";
import XcelEnergy from "public/customerLogos/xcelenergy.png";
import SheetMetalW from "public/customerLogos/sheetmetalw.png";
import Smw104 from "public/customerLogos/smw104.png";
import Teradar from "public/customerLogos/teradar.png";
import Siemens from "public/customerLogos/siemens.png";
import Woodstream from "public/customerLogos/woodstream.png";
import Zimvie from "public/customerLogos/zimvie.png";

export const CUSTOMER_CONSTANTS = {
  TITLE: "Our Customers: Global Enterprises Trust OneMind Services",
};

export const CUSTOMERS_LIST = [
  { image: Absolute, name: "Absolute", href: "https://www.absolute.com/" },
  { image: Airtel, name: "Airtel", href: "https://www.airtel.com/" },
  { image: Amadeus, name: "Amadeus", href: "https://amadeus.com/" },
  {
    image: CoveredCalifornia,
    name: "Covered California",
    href: "https://www.coveredca.com/",
  },
  { image: Helpage, name: "HelpAG", href: "https://www.helpag.com/" },
  { image: Hpe, name: "HPE", href: "https://www.hpe.com/" },
  { image: Italtel, name: "Italtel", href: "https://www.italtel.com/" },
  { image: Mgic, name: "MGIC", href: "https://www.mgic.com/" },
  { image: Nsc, name: "NSC", href: "https://www.nsc.org/" },
  { image: Ntt, name: "NTT", href: "https://www.global.ntt/" },
  { image: OnxCanada, name: "OnX Canada", href: "https://www.onx.com/" },
  { image: Opentext, name: "OpenText", href: "https://www.opentext.com/" },
  { image: Sdaia, name: "SDAIA", href: "https://sdaia.gov.sa/" },
  { image: Shi, name: "SHI", href: "https://www.shi.com/" },
  { image: Shu, name: "SHU", href: "https://www.shu.ac.uk/" },
  { image: SoftwareOne, name: "SoftwareONE", href: "https://www.softwareone.com/" },
  { image: TeConnectivity, name: "TE Connectivity", href: "https://www.te.com/" },
  { image: Toyota, name: "Toyota", href: "https://www.toyota-global.com/" },
  { image: Uroclear, name: "Uroclear", href: "https://uroclear.com/" },
  { image: XcelEnergy, name: "Xcel Energy", href: "https://www.xcelenergy.com/" },
  {
    image: SheetMetalW,
    name: "Sheet Metal Workers' International Association",
    href: "https://www.smart-union.org/",
  },

  { image: Smw104, name: "SMW Local 104", href: "https://www.smw104.org/" },
  { image: Teradar, name: "Teradar", href: "https://teradar.com/" },
  { image: Siemens, name: "Siemens", href: "https://www.siemens.com/" },
  { image: Woodstream, name: "Woodstream", href: "https://www.woodstream.com/" },
  { image: Zimvie, name: "ZimVie", href: "https://www.zimvie.com/" },
];
